import axios from 'axios';

function detetoken() {
  var token = JSON.parse(localStorage.getItem("token"))
  axios.get(
    "/token/check?", //请求的后台接口
    {
      params: {
        token: token,
      }, //传给后台的参数
    }).then(({
      data
    }) => {
      console.log("验证token=》", data);
      if (data.data.expires_in < 1440) {
        axios.get(
          "/token/refresh?", //请求的后台接口
          {
            params: {
              token: token,
            }, //传给后台的参数
          }).then(({
            data
          }) => {
            console.log("刷新token=》", data);
          })
      }
    })
}
// 拿到内网的token,跳API
function gettoken2() {
  var account = JSON.parse(localStorage.getItem("account"))
  var password = JSON.parse(localStorage.getItem("password"))
  var rpcPath = '/iidp/api/root/rpc/login'
  var tokenUrl = window.location.origin + rpcPath
  var basePath = '/iidp/base/base_developer_center/base_documents_menu?token='
  var baseUrl = window.location.origin + basePath
  axios.post(
    tokenUrl, //请求的后台接口
    {
      id: "login",
      jsonrpc: "2.0",
      method: "login",
      params: {
        login: account,
        remember: false
      }

    }, //传给后台的参数 
    {
      headers: {
        "clientId": '932ff1f173e145da9f39a967988e5f41'
      }
    }
  ).then(({
    data
  }) => { 
    console.log("内网token=》", data);
    localStorage.setItem(
      "token2",
      JSON.stringify(data.result.data.token)
    );
    console.log(JSON.parse(localStorage.getItem("token2")))
    if (JSON.parse(localStorage.getItem("token2"))) {
      var url = baseUrl + JSON.parse(localStorage.getItem("token2"))+'&userId='+JSON.parse(localStorage.getItem("userId"))
      // var url = 'http://192.168.175.213/snest?token='+JSON.parse(localStorage.getItem("token2"))
      console.log(url)
      window.open(url, "_blank");
    }
  })
}
// 跳内网控制台方法
function controll() {
  var account = JSON.parse(localStorage.getItem("account"))
  var password = JSON.parse(localStorage.getItem("password"))
  var onePath = '/iidp/api/root/rpc/login'
  var oneUrl = window.location.origin + onePath
  var twoPath = '/iidp/zxqyfwpt?userId='
  var twoUrl = window.location.origin + twoPath
  axios.post(
    oneUrl, //请求的后台接口
    {
      id: "login",
      jsonrpc: "2.0",
      method: "login",
      params: {
        login: account,
        remember: false
      }

    }, //传给后台的参数 
    {
      headers: {
        "clientId": '932ff1f173e145da9f39a967988e5f41'
      }
    }
  ).then(({
    data
  }) => {
    console.log("内网token=》", data);
    localStorage.setItem(
      "token2",
      JSON.stringify(data.result.data.token)
    );
    localStorage.setItem(
      "userId",
      JSON.stringify(data.result.data.id)
    );
    console.log(JSON.parse(localStorage.getItem("token2")))
    if (JSON.parse(localStorage.getItem("token2"))) {
      var url = twoUrl + JSON.parse(localStorage.getItem("userId"))+'&token='+JSON.parse(localStorage.getItem("token2"));
      // var url = 'http://192.168.175.213/snest?token='+JSON.parse(localStorage.getItem("token2"))
      console.log(url)
      window.open(url, "_blank");
    }
  })
}

function getK() {
  var account = JSON.parse(localStorage.getItem("account"))
  var password = JSON.parse(localStorage.getItem("password"))
  var threePath = '/admin/index/ajax_login?'
  var threeUrl = window.location.origin + threePath
  axios.get(
    threeUrl, //请求的后台接口
    {
      params: {
        username: account,
        password: password,
      }, //传给后台的参数
    },
    {
      headers: {
        "Access-Control-Allow-Origin": '*'
      }
    }
  )
    .then(({
      data
    }) => {
      console.log("成功=》", data);
      window.open(data.data, "_blank");
    });
}
// 跳转到赛意数字平台
function shuzi() {
  var account = JSON.parse(localStorage.getItem("account"))
  var password = JSON.parse(localStorage.getItem("password"))
  var fourPath = '/iidp/api/root/rpc/login'
  var fourUrl = window.location.origin + fourPath
  var fivePath = '/iidp/?pageId=chart-runpage&id=02zqsbqwa6vpc&userId='
  var fiveUrl = window.location.origin + fivePath
  axios.post(
    fourUrl, //请求的后台接口
    {
      id: "login",
      jsonrpc: "2.0",
      method: "login",
      params: {
        login: account,
        remember: false
      }

    }, //传给后台的参数 
    {
      headers: {
        "clientId": '932ff1f173e145da9f39a967988e5f41'
      }
    }
  ).then(({
    data
  }) => {
    console.log("内网token=》", data);
    localStorage.setItem(
      "token2",
      JSON.stringify(data.result.data.token)
    );
    localStorage.setItem(
      "userId",
      JSON.stringify(data.result.data.id)
    );
    console.log(JSON.parse(localStorage.getItem("token2")))
    if (JSON.parse(localStorage.getItem("token2"))) {
      var url = fiveUrl + JSON.parse(localStorage.getItem("userId"))+'&token='+JSON.parse(localStorage.getItem("token2"));
      console.log(url)
      window.open(url, "_blank");
    }
  })
}
//将方法暴露出来
export default {
  detetoken,
  gettoken2,
  controll,
  getK,
  shuzi
}
